import { ThemeType } from 'shared/interfaces';

export const defaultThemeSettings: ThemeType = {
    id: '1',
    name: 'default',
    logo: '',
    buttonRadius: '50',
    primaryColor: '#444444',
    secondaryColor: '#444444',
    tertiaryColor: '',
    backgroundColor: '#ffffff',
    primaryButton: {
        backgroundColor: '#444444',
        fontColor: '#ffffff',
        borderColor: '#444444',
    },
    secondaryButton: {
        backgroundColor: '#ffffff',
        fontColor: '#444444',
        borderColor: '#444444',
    },
    header: {
        backgroundColor: '#444444',
        fontColor: '#ffffff',
        borderColor: '#444444',
    },
    footer: {
        backgroundColor: '#444444',
        fontColor: '#ffffff',
        borderColor: '#444444',
    },
};
